import { ErrorsComponent } from './../modals/errors/errors.component';
import { Subscription } from 'rxjs';
import { SaveChangesComponent } from './../modals/save-changes/save-changes.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetService } from 'src/app/Services/get.service';
import { PostService } from 'src/app/Services/post.service';
import { environment } from 'src/environments/environment';
import { contentLists } from '../contentForms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessComponent } from '../modals/success/success.component';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit, OnDestroy {
  viewClicked: boolean;
  contentTypeData: any; // the data loaded for this type of content --here is sections
  type: string; // the content type from url and get data from content array
  id: string;
  mainForm: FormGroup;
  lang: string = 'en';
  fieldsCtrls = {};
  getRecordLink: string; // the whole page data recieved from the api
  postEditLink: string;
  recordData: any;
  imageUrl; //image url in the backend api
  formData: FormData; //form data object  form data
  imageSrc = new Map(); //get all the image links to display
  imagesFieldsList = ['image', 'image_ar', 'icon', 'icon_ar']; // to deal with all image fields to handle them as special case in create form or formdata
  imageSizeError = new Map(); //array to have the error of file input validation
  hidearbicMedia: boolean;
  hidearabicIcon: boolean;
  HidearabicDark: boolean;
  hidearabicIMage: boolean;
  editSubscription = new Subscription();
  getEditDataSubscription = new Subscription();
  backendErrors = new Array();
  routerList;
  backLink;
  dimension;
  slelectedBtn;
  chars;
  newChars=[];
  btnTypes = [{ value: 'none', viewValue: 'None' },
  { value: 'internal_link', viewValue: 'Internal Link' },
  { value: 'external_link', viewValue: 'External Link' },
  { value: 'whatsapp', viewValue: 'Whatsapp' },
  { value: 'phone', viewValue: 'Phone' },
];
  modules = {
    formula: true,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: [false] }], // custom dropdown
      [{ header: [false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [false] }],
      [{ align: [] }],

      ['clean'], // remove formatting button

      ['link'], // link and image, video
    ],
  };
  constructor(
    private get: GetService,
    private route: ActivatedRoute,
    private post: PostService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private router: Router,
    private datepipe: DatePipe,
    private element: ElementRef,
    public _domSanitizer: DomSanitizer
  ) {
    this.type = route.snapshot.paramMap.get('type');
    this.id = route.snapshot.paramMap.get('id');
    this.contentTypeData = contentLists[this.type];
    this.getRecordLink = contentLists[this.type].getRecordLink;
    this.postEditLink = contentLists[this.type].postEditLink;
    this.formData = new FormData();

    this.createForm(this.contentTypeData.edit_form.english);

    if (this.contentTypeData.hasCommon) {
      this.createForm(this.contentTypeData.edit_form.common);
    }
    if (this.contentTypeData.hasHidden) {
      this.createForm(this.contentTypeData.edit_form.hidden);
    }
    if (this.contentTypeData.hasArabic) {
      this.createForm(this.contentTypeData.edit_form.arabic);
    }

    this.mainForm = new FormGroup(this.fieldsCtrls);

    this.imageUrl = environment.imgUrl;
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }
  createForm(fields) {
    let is_required;
    for (let f of fields) {
      if (f.required) {
        is_required = Validators.required;
      } else {
        is_required = null;
      }

      this.fieldsCtrls[f.name] = new FormControl(f.value || '', is_required);
      if (f.type == 'file' || f.type == 'doc') {
        this.imageSrc[f.name] = f.value;
        this.imageSizeError[f.name] = false;
      }
      if (f.type == 'date') {
      }
    }
  }

  ngOnInit(): void {

    this.spinner.show();
    this.backLink = this.contentTypeData.backLink;
    this.routerList = this.contentTypeData.routerList;
    if (this.type == 'cali_units_gallery' || this.type == 'cali_units') {
      this.get.get('dashboard/cali_units/dimensions').subscribe((dimensions) => {
        this.dimension = dimensions.response.data;
        // console.log(this.dimension);

      })
    }
    this.getRecordData();
  }
  openDialog() {
    this.mainForm.markAllAsTouched();
    if (!this.mainForm.valid) {
      this.submit();
    }
    if (this.mainForm.valid) {
      const dialogref = this.dialog.open(SaveChangesComponent, {
        data: 'Are You sure you want to save edits?',
      });
      dialogref.afterClosed().subscribe((reply) => {
        if (reply) {
          this.submit();
        }
      });
    }
  }

  submit() {
    this.mainForm.markAllAsTouched();
    this.spinner.show();
    let fields = [];
    fields = fields.concat(this.contentTypeData.edit_form.english);
    if (this.contentTypeData.hasCommon == true) {
      fields = fields.concat(this.contentTypeData.edit_form.common);
    }
    if (this.contentTypeData.hasHidden == true) {
      fields = fields.concat(this.contentTypeData.edit_form.hidden);
    }
    if (this.contentTypeData.hasArabic == true) {
      fields = fields.concat(this.contentTypeData.edit_form.arabic);
    }

    if (!this.mainForm.valid) {
      this.spinner.hide();
      console.log(this.mainForm.value);
      
      const dialogref = this.dialog.open(ErrorsComponent, { data: 'Please Make Sure To Fill Both English & Arabic Fields' })
      dialogref.afterClosed().subscribe((reply) => {
        if (reply) {
          this.dialog.closeAll();
        }
      })
      return;
    }



    // console.log('fieldsfieldsfieldsfieldsfieldsfields',fields);
    var value;

    for (let f of fields) {
      if (f.type == 'file' || f.type == 'doc') {
      } else if (f.type == 'date') {
        value = this.mainForm.get(f.name).value;
        this.datepipe.transform(value, 'yyyy-MM-dd');
        this.formData.append(
          f.name,
          this.datepipe.transform(value, 'yyyy-MM-dd')
        );
      } else {
        value = this.mainForm.get(f.name).value;
        this.formData.append(f.name, value);
      }
    }

    this.spinner.show();
    this.editSubscription = this.post
      .submit(this.postEditLink + this.id, this.formData)
      .subscribe(
        (res) => {
          this.mainForm.patchValue(res.response.data);
          this.dialog.open(SuccessComponent);
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
          setTimeout(() => {
            this.router.navigate([this.routerList]);
          }, 1500);
        },
        (error) => {
          this.spinner.hide();
          this.backendErrors = error.error.errors;
          console.log(this.backendErrors);
   
          for (let errElement in this.backendErrors) {
            
            for (let errItem = 0; errItem < this.backendErrors[errElement].length; errItem++) {
              const item = this.backendErrors[errElement][errItem];
                          
              const dialogref = this.dialog.open(ErrorsComponent, { data: item })
              dialogref.afterClosed().subscribe((reply) => {
                if (reply) {
                  this.dialog.closeAll();
                }
              })
            }
          }
        }
      
      );

  }
  textChange(e, content){
    console.log(e,content);
   this.newChars = (content.replace( /(<([^>]+)>)/ig, '')).length;
  }
  getRecordData() {
    this.getEditDataSubscription = this.get
      .get(this.getRecordLink + this.id)
      .subscribe((res) => {
        switch (this.type) {
          case 'cali_units_gallery':
            case 'baymount_units_gallery':
            // console.log(res.response.data);
            this.recordData = res.response.data;
            break;
          case 'media':
            this.recordData = res.response.data.media;
            break;
          case 'home_about':
          case 'home_media':
          case 'home_sister_company':
          case 'home_partners':
          case 'partners':
          case 'about_values':
          case 'about_values':
          case 'contact_projects':
          case 'about_directors':
          case 'contact_requests':
          case 'contact_addresses':
          case 'contact_projects':
          case 'about_sister_company':
          case 'menu_pages':
          case 'cali_map':
          case 'cali_partners_details':
          case 'cali_statistics':
          case 'cali_partners':
          case 'cali_inquiry_time':
          case 'cali_inquiry_unit':
          case 'cali_masterplan':
            case 'baymount_map':
              case 'baymount_statistics':
              case 'baymount_masterplan':
              case 'baymount_partners':
              case 'baymount_inquiry_unit':
              case 'baymount_inquiry_time':
          case 'axa_benefits':
          case 'axa_additional_services':
          case 'axa_inquiry_projects':
          case 'customer_care_phone':
          case 'offers_inquiry_project':
            this.recordData = res.response.data.element;
            break;

          default:
            this.recordData = res.response.data;
            break;
        }

        this.mainForm.patchValue(this.recordData);
        this.renderingSectionImages();
        if (this.mainForm.get('category_id')) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('category_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('category_id').value;
        } else if (this.mainForm.get('media_category_id')) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('media_category_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('media_category_id').value;
        } else if (this.mainForm.get('media_id')) {
          this.backLink =
            this.contentTypeData.backLink + this.mainForm.get('media_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('media_id').value;
        } else if (this.mainForm?.get('section_id')?.value) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('section_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('section_id').value;
        } else if (this.mainForm?.get('cali_unit_id')?.value) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('cali_unit_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('cali_unit_id').value;
        } else if (this.mainForm?.get('baymount_unit_id')?.value) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('baymount_unit_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('baymount_unit_id').value;
        }
        else if (this.mainForm?.get('offers_section_id')?.value) {
          this.backLink =
            this.contentTypeData.backLink +
            this.mainForm.get('offers_section_id').value;
          this.routerList =
            this.contentTypeData.routerList +
            this.mainForm.get('offers_section_id').value;
        }
        else {
          this.backLink = this.contentTypeData.backLink;
          this.routerList = this.contentTypeData.routerList;
        }
      });
   
      
  }

  renderingSectionImages() {
    // this.fillFormData();
    for (let fieldName in this.imageSrc) {
      this.imageSrc[fieldName] = this.imageUrl + this.recordData[fieldName];
    }
  }
  triggerClick(fieldID) {
    document.getElementById(fieldID).click();
  }

  upload(event, fieldName) {
    // this.progress = 1;
    let file;
    let fileSize;
    const files: File = event.target.files;
    file = files[0];
    fileSize = Math.round(file.size / 1024);

    let vaildSize = fileSize <= 9216;

    const reader = new FileReader();

    if (event.target.files.length && vaildSize) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imageSrc[fieldName] = reader.result as string;
        var obj = {};
        obj[fieldName] = event.target.files[0];
        this.formData.append(fieldName, event.target.files[0]);
      };
    } else {
      this.imageSizeError[fieldName] = true;
    }
  }
  fillFormData() {
    let field;
    for (field in this.recordData) {
      if (!Array.isArray(this.recordData[field])) {
      }
    }
  }
  onCheckboxChange(fieldName, value) {
    if (value == 0) {
      document.getElementById(fieldName + '-container').classList.add('d-none');
    } else {
      document.getElementById(fieldName + '-container').classList.remove('d-none');
    }
  }
  ngOnDestroy(): void {
    this.editSubscription.unsubscribe();
    this.getEditDataSubscription.unsubscribe();
  }
}
